import type { InputSource } from '../types';
import { drawDisguiseLogo } from '../utils/draw-disguise-logo';

export function drawCrosshatch(
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  x = 0,
  y = 0,
  spacing = 20
) {
  ctx.fillStyle = 'white';
  ctx.fillRect(x, y, width, height);

  ctx.strokeStyle = '#000000';
  ctx.lineWidth = 1;

  for (let i = 0; i <= width; i += spacing) {
    ctx.beginPath();
    ctx.moveTo(x + i, y);
    ctx.lineTo(x + i, y + height);
    ctx.stroke();
  }

  for (let i = 0; i <= height; i += spacing) {
    ctx.beginPath();
    ctx.moveTo(x, y + i);
    ctx.lineTo(x + width, y + i);
    ctx.stroke();
  }

  // Draw center crosshairs (thicker)
  ctx.strokeStyle = '#FF0000';
  ctx.lineWidth = 3;

  ctx.moveTo(x, y + height / 2);
  ctx.lineTo(x + width, y + height / 2);
  ctx.stroke();

  // Add corner markers
  ctx.fillStyle = '#FF0000';
  const markerSize = 10;

  ctx.fillRect(x, y, markerSize, markerSize);
  ctx.fillRect(x + width - markerSize, y, markerSize, markerSize);
  ctx.fillRect(x, y + height - markerSize, markerSize, markerSize);
  ctx.fillRect(x + width - markerSize, y + height - markerSize, markerSize, markerSize);

  drawDisguiseLogo(ctx, width, height, x, y, 'black');
}

export const crosshatch: InputSource = {
  label: 'Crosshatch',
  value: 'crosshatch',
  draw: (ctx, width, height) => {
    drawCrosshatch(ctx, width, height);
  },
};
